import React from 'react';
import Radium from 'radium';
import CheckBocks from '../components/CheckBocks';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { required, phone, email } from '../utilities/validations';

const inputBlockStyles = {
  marginBottom: "2em",
}
const inputStyles = {
  minWidth: "300px",
  width: "90%",
  marginTop: ".25em",
};

const labelStyles = {
  display: "block",
  marginBottom: 0,
}

const Input = ({ name, label, type }) => {
  return (
    <div style={inputBlockStyles}>
      <label style={labelStyles}>{ label }</label>
      <input name={name} type={type} style={inputStyles}/>
    </div>);
};



const Request = ({handleSubmit, onFormSubmit, submitting}) => {

  return (
    <section className="page-max full-height p3 mb4" style={{paddingTop: "3em"}}>
      <div>
        <div className="mb3">
          <h1>Request a Print Copy of Humanly Magazine</h1>
          <p>Fill out the form below to receive the latest issue in the mail.</p>
        </div>
        <div>
          <form name="mc-embedded-subscribe-form" action="https://theculturecoop.us17.list-manage.com/subscribe?u=feeeaa18dc42620cc07eb7cbe&id=bb002890ff" method="POST">
            <div className="clearfix">
              <div className="lg-col lg-col-6">
                <Input name='NAME' label='Name' type="text" style={inputStyles}/>
                <Input name='TITLE' label='Title' type="text" style={inputStyles}/>
                <Input name='COMPANY' label='Company' type="text" style={inputStyles}/>
                <Input name='PHONE' label='Phone' type="text" style={inputStyles}/>
                <Input name='EMAIL' label='E-mail' type="text" style={inputStyles}/>
              </div>
              <div className="lg-col lg-col-6">
                <Input name='ADDRESS[addr1]' label='Mailing Address (Line 1)' type="text" style={inputStyles}/>
                <Input name='ADDRESS[addr2]' label='Mailing Address (Line 2)' type="text" style={inputStyles}/>
                <Input name='ADDRESS[city]' label='City' type="text" style={inputStyles}/>
                <Input name='ADDRESS[state]' label='State' type="text" style={inputStyles}/>
                <Input name='ADDRESS[zip]' label='Zip' type="text" style={inputStyles}/>
              </div>
            </div>
            <div>
              {/* <p><CheckBocks isChecked={true}/><span className="ml2">I would you like to receive email updates about new Humanly content.</span></p> */}
            </div>
            <div>
              <button type="submit">Request a Copy</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  )
};

const mapStateToProps = state => {
  return {};
};

const mapDispatchToProps = dispatch => {
  return {
    onFormSubmit(json) {
      // fetch('https://us17.api.mailchimp.com/3.0/lists/bb002890ff/members/', {
      //   body: JSON.stringify({
      //     email_address: json.email,
      //     status: "subscribed",
      //     merge_fields: {
      //       "NAME": json.name,
      //       "ADDRESS": json.address1 + " " + json.address2 + " " + json.city + " " + json.state + " " + json.zip,
      //       "TITLE": json.title,
      //       "COMPANY": json.company,
      //       "PHONE": json.phone,
      //     },
      //   }),
      //   method: 'POST'
      // })
    }
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Radium(Request));



// WEBPACK FOOTER //
// ./src/pages/Request.js